import React from "react";
import { Modal } from "react-bootstrap";
import { ChevronRightIcon } from "../../StrategyCanvasHelpers";
import "./LiveReviewInfoModal.scss";

// Describes how the screen actually behaves: the agenda is a reference list
// you click through, and the canvas on the left is where the work happens.
const STEPS = [
  <>
    Confirm the <strong>CEO</strong> is with you
  </>,
  <>
    Click any <strong>agenda item</strong> to jump to it on the canvas
  </>,
  <>
    Talk it through, then <strong>Modify</strong> the wording together if it
    needs to change
  </>,
  <>
    <strong>Finalise</strong> each block once you&apos;re both happy with it
  </>,
  <>
    <strong>Lock the canvas</strong> when every block is finalised
  </>,
];

// Figma node 33450-155220 (small info frame) - the info popup opened from
// the "i" icon in the Live Review header, explaining what happens once the
// coach starts the joint session with the CEO.
const LiveReviewInfoModal = ({ onClose }) => (
  <Modal
    show
    onHide={onClose}
    centered
    dialogClassName="lrim-dialog"
    contentClassName="lrim-content"
  >
    <Modal.Body className="lrim-body">
      <h3 className="lrim-title">Start the live review</h3>
      <p className="lrim-subtitle">
        Run this with the CEO and their leadership team, in person or on a
        video call.
      </p>
      <p className="lrim-text">
        Your solo review is done, so now you&apos;ll work through it together.
        The <strong>Meeting Agenda</strong> on the right is your running order —
        nothing to tick off, just click an item to bring it up on the canvas.
        Every decision is made on the canvas itself, and the review is complete
        when every block has been finalised.
      </p>
      <p className="lrim-text">
        Make sure the CEO is with you before you start, because once you begin
        you can&apos;t step back to the previous stage.
      </p>

      <ol className="lrim-steps">
        {STEPS.map((step, index) => (
          <li key={index}>{step}</li>
        ))}
      </ol>

      <div className="lrim-divider" />

      <div className="lrim-footer">
        <button type="button" className="lrim-ok-btn" onClick={onClose}>
          Okay
          <ChevronRightIcon />
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export default LiveReviewInfoModal;
